import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../environments/environment';
import { AppService } from './app.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CoreApiService {
  public api = environment.apiBackend;
  constructor(
    private readonly http: HttpClient,
    private readonly spinner: NgxSpinnerService,
    private readonly appService: AppService,
  ) {}

  public consumirWSPost(
    metodo: any,
    params: any,
    callback: (arg0: any) => void,
    silent = false,
  ) {
    if (!silent) this.spinner.show();
    this.sendDataCorePost(metodo, params).subscribe({
      next: (datos: any) => {
        if (!silent) this.spinner.hide();
        callback(datos);
      },
      error: (e: any) => {
        if (!silent) this.spinner.hide();
        if (e.status === 401) {
          this.appService.eliminarSesion();
        }
        callback({
          estado: e.status,
          mensaje: e.error?.mensaje || 'Error inesperado',
          error: true,
          data: null,
        });
      },
    });
  }

  public consumirWSPut(
    metodo: any,
    params: any,
    callback: (arg0: any) => void,
  ) {
    this.spinner.show();
    this.sendDataCorePut(metodo, params).subscribe({
      next: (datos: any) => {
        this.spinner.hide();
        callback(datos);
      },
      error: (e: any) => {
        this.spinner.hide();
        if (e.status === 401) {
          this.appService.eliminarSesion();
        }
        callback({
          estado: e.status,
          mensaje: e.error?.mensaje || 'Error inesperado',
          error: true,
          data: null,
        });
      },
    });
  }

  public consumirWSGet(
    metodo: string,
    params: any,
    callback: (arg0: any) => void,
  ) {
    this.spinner.show();

    this.sendDataCoreGet(metodo, params).subscribe({
      next: (datos: any) => {
        this.spinner.hide();
        callback(datos);
      },
      error: (e: any) => {
        this.spinner.hide();
        if (e.status === 401) {
          this.appService.eliminarSesion();
        }
        callback({
          estado: e.status,
          mensaje: e.error?.mensaje || 'Error inesperado',
          error: true,
          data: null,
        });
      },
    });
  }

  public sendDataCorePost(metodo: string, params: any): Observable<Object> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.api + metodo, params, { headers });
  }

  public sendDataCorePut(metodo: string, params: any): Observable<Object> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.put(this.api + metodo, params, { headers });
  }

  public sendDataCore(metodo: string, params: any): Observable<Object> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get(this.api + metodo, { headers, params });
  }

  public sendDataCoreGet(metodo: string, params: any): Observable<Object> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get(this.api + metodo, { headers, params });
  }

  public consumirWSFilePost(
    metodo: any,
    params: any,
    callback: (arg0: any) => void,
  ) {
    this.spinner.show();
    this.sendDataCoreFilePost(metodo, params).subscribe({
      next: (datos) => {
        this.spinner.hide();
        callback(datos);
      },
      error: (e: any) => {
        this.spinner.hide();
        if (e.status === 401) {
          this.appService.eliminarSesion();
        }
        callback({
          estado: e.status,
          mensaje: e.error?.mensaje || 'Error inesperado',
          error: true,
          data: null,
        });
      },
    });
  }

  public sendDataCoreFilePost(metodo: string, params: any): Observable<Object> {
    return this.http.post(this.api + metodo, params);
  }

  downloadFile(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' });
  }
}
